import React, { useMemo, useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useParams, useLocation } from "react-router-dom";
import { normalizeSections } from "../Draft/ProposalDraftStep";
import Tooltip from "../../../Project Page/Tooltip";
import api from "../../../../../chat/api";

const EDIT_TOOLTIP =
  "You will be redirected to the Draft step to edit or regenerate this section. Changes made in Draft will update the proposal preview once saved.";



  const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.41797 4.85639C1.41797 3.94395 1.78044 3.06887 2.42563 2.42368C3.07083 1.77848 3.9459 1.41602 4.85834 1.41602H8.5013C8.68916 1.41602 8.86933 1.49064 9.00217 1.62348C9.13501 1.75632 9.20964 1.93649 9.20964 2.12435C9.20964 2.31221 9.13501 2.49238 9.00217 2.62522C8.86933 2.75805 8.68916 2.83268 8.5013 2.83268H4.85834C4.32162 2.83268 3.80688 3.04589 3.42737 3.42541C3.04785 3.80493 2.83464 4.31967 2.83464 4.85639V12.1423C2.83464 12.679 3.04785 13.1938 3.42737 13.5733C3.80688 13.9528 4.32162 14.166 4.85834 14.166H12.1443C12.681 14.166 13.1957 13.9528 13.5752 13.5733C13.9548 13.1938 14.168 12.679 14.168 12.1423V8.49935C14.168 8.31149 14.2426 8.13132 14.3754 7.99848C14.5083 7.86564 14.6884 7.79102 14.8763 7.79102C15.0642 7.79102 15.2443 7.86564 15.3772 7.99848C15.51 8.13132 15.5846 8.31149 15.5846 8.49935V12.1423C15.5846 13.0548 15.2222 13.9298 14.577 14.575C13.9318 15.2202 13.0567 15.5827 12.1443 15.5827H4.85834C3.9459 15.5827 3.07083 15.2202 2.42563 14.575C1.78044 13.9298 1.41797 13.0548 1.41797 12.1423V4.85639Z" fill="#797979"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7236 9.3623L9.16177 10.3044L8.43006 9.09101L9.99194 8.14892L9.99406 8.14751C10.0539 8.11145 10.1091 8.06816 10.1584 8.01859L13.7071 4.45142C13.7427 4.41559 13.7769 4.37849 13.8099 4.34022C14.0443 4.0668 14.3914 3.52563 13.9714 3.10347C13.6165 2.74647 13.1079 3.08363 12.7785 3.37334C12.6902 3.45123 12.6051 3.53276 12.5235 3.61772L12.4994 3.6418L9.00027 7.15867C8.91719 7.24127 8.85208 7.34014 8.80902 7.44909L8.22535 8.91747C8.21428 8.9451 8.2122 8.97551 8.21939 9.00439C8.22659 9.03328 8.2427 9.05916 8.26544 9.07837C8.28817 9.09758 8.31638 9.10914 8.34606 9.1114C8.37574 9.11367 8.40467 9.10654 8.43006 9.09101L9.16177 10.3044C7.88323 11.0751 6.35677 9.78022 6.90927 8.3933L7.49365 6.92563C7.60742 6.63883 7.77855 6.37827 7.99656 6.15992L11.495 2.64234L11.5156 2.6218C11.6197 2.51555 11.9696 2.15713 12.3939 1.8993C12.6255 1.75976 12.9953 1.57488 13.4521 1.53947C13.9763 1.49767 14.5359 1.66272 14.9751 2.10401C15.3112 2.43607 15.5226 2.87386 15.5736 3.34359C15.6087 3.70973 15.5527 4.07886 15.4107 4.41813C15.2053 4.92601 14.8624 5.2993 14.7116 5.45018L11.1628 9.01734C11.0306 9.15004 10.8842 9.26502 10.7236 9.3623ZM13.8779 4.31472C13.8779 4.31472 13.875 4.31684 13.8686 4.31897L13.8779 4.31472Z" fill="#797979"/>
</svg>
);

const DragHandle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" aria-hidden="true">
    <path d="M1.58333 12.6667C1.14792 12.6667 0.775174 12.5116 0.465104 12.2016C0.155035 11.8915 0 11.5187 0 11.0833C0 10.6479 0.155035 10.2752 0.465104 9.9651C0.775174 9.65504 1.14792 9.5 1.58333 9.5C2.01875 9.5 2.39149 9.65504 2.70156 9.9651C3.01163 10.2752 3.16667 10.6479 3.16667 11.0833C3.16667 11.5187 3.01163 11.8915 2.70156 12.2016C2.39149 12.5116 2.01875 12.6667 1.58333 12.6667ZM6.33333 12.6667C5.89792 12.6667 5.52517 12.5116 5.2151 12.2016C4.90503 11.8915 4.75 11.5187 4.75 11.0833C4.75 10.6479 4.90503 10.2752 5.2151 9.9651C5.52517 9.65504 5.89792 9.5 6.33333 9.5C6.76875 9.5 7.14149 9.65504 7.45156 9.9651C7.76163 10.2752 7.91667 10.6479 7.91667 11.0833C7.91667 11.5187 7.76163 11.8915 7.45156 12.2016C7.14149 12.5116 6.76875 12.6667 6.33333 12.6667ZM1.58333 7.91667C1.14792 7.91667 0.775174 7.76163 0.465104 7.45156C0.155035 7.14149 0 6.76875 0 6.33333C0 5.89792 0.155035 5.52517 0.465104 5.2151C0.775174 4.90503 1.14792 4.75 1.58333 4.75C2.01875 4.75 2.39149 4.90503 2.70156 5.2151C3.01163 5.52517 3.16667 5.89792 3.16667 6.33333C3.16667 6.76875 3.01163 7.14149 2.70156 7.45156C2.39149 7.76163 2.01875 7.91667 1.58333 7.91667ZM6.33333 7.91667C5.89792 7.91667 5.52517 7.76163 5.2151 7.45156C4.90503 7.14149 4.75 6.76875 4.75 6.33333C4.75 5.89792 4.90503 5.52517 5.2151 5.2151C5.52517 4.90503 5.89792 4.75 6.33333 4.75C6.76875 4.75 7.14149 4.90503 7.45156 5.2151C7.76163 5.52517 7.91667 5.89792 7.91667 6.33333C7.91667 6.76875 7.76163 7.14149 7.45156 7.45156C7.14149 7.76163 6.76875 7.91667 6.33333 7.91667ZM1.58333 3.16667C1.14792 3.16667 0.775174 3.01163 0.465104 2.70156C0.155035 2.39149 0 2.01875 0 1.58333C0 1.14792 0.155035 0.775174 0.465104 0.465104C0.775174 0.155035 1.14792 0 1.58333 0C2.01875 0 2.39149 0.155035 2.70156 0.465104C3.01163 0.775174 3.16667 1.14792 3.16667 1.58333C3.16667 2.01875 3.01163 2.39149 2.70156 2.70156C2.39149 3.01163 2.01875 3.16667 1.58333 3.16667ZM6.33333 3.16667C5.89792 3.16667 5.52517 3.01163 5.2151 2.70156C4.90503 2.39149 4.75 2.01875 4.75 1.58333C4.75 1.14792 4.90503 0.775174 5.2151 0.465104C5.52517 0.155035 5.89792 0 6.33333 0C6.76875 0 7.14149 0.155035 7.45156 0.465104C7.76163 0.775174 7.91667 1.14792 7.91667 1.58333C7.91667 2.01875 7.76163 2.39149 7.45156 2.70156C7.14149 3.01163 6.76875 3.16667 6.33333 3.16667Z" fill="#797979"/>
  </svg>
);

const formatNumber = (num) => String(num ?? "").replace(/\.+$/, "");

// Driven purely by node.markAsDone (the API's mark_as_done) — not by content.
const StatusBadge = ({ done }) => (
  <span
    className={`px-2 py-0.5 rounded-md font-outfit text-[12px] font-medium ${
      done ? "bg-[#45876429] text-[#458764]" : "bg-[#FBF3E2] text-[#B7791F]"
    }`}
  >
    {done ? "Done" : "Pending"}
  </span>
);

const NodeContent = ({ html, clamp = false }) =>
  html && html.trim() ? (
    <div
      className="proposal-review-content font-outfit text-[15px] text-[#3F3F46] leading-relaxed mt-3"
      style={
        clamp
          ? {
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }
          : undefined
      }
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : (
    <p className="mt-3 text-[#9CA3AF] font-outfit text-sm italic">
      This section does not contain generated content yet.
    </p>
  );

const ChevronIcon = ({ collapsed }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    className={`transition-transform ${collapsed ? "" : "rotate-180"}`}
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" stroke="#52525B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DotsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#52525B" aria-hidden="true">
    <circle cx="5" cy="12" r="1.7" />
    <circle cx="12" cy="12" r="1.7" />
    <circle cx="19" cy="12" r="1.7" />
  </svg>
);

// "•••" menu → popover with Move to Top / Move to Bottom. Renders nothing when
// no move handlers are supplied (e.g. the unnumbered, non-reorderable node).
// The popover is portaled to <body> with fixed positioning so it is never
// clipped by the scrolling card list, and flips above the button when there is
// not enough room below.
const ActionMenu = ({ onMoveTop, onMoveBottom }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: "auto", bottom: "auto", right: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const updatePosition = () => {
    const el = btnRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const menuHeight = 110; // approx height of the two-item popover
    const spaceBelow = window.innerHeight - rect.bottom;
    const flipUp = spaceBelow < menuHeight + 12 && rect.top > menuHeight;
    setPos({
      top: flipUp ? "auto" : rect.bottom + 6,
      bottom: flipUp ? window.innerHeight - rect.top + 6 : "auto",
      right: window.innerWidth - rect.right,
    });
  };

  useEffect(() => {
    if (!open) return undefined;
    updatePosition();
    const onDoc = (e) => {
      if (
        btnRef.current &&
        !btnRef.current.contains(e.target) &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      )
        setOpen(false);
    };
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);
    document.addEventListener("mousedown", onDoc);
    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
      document.removeEventListener("mousedown", onDoc);
    };
  }, [open]);

  if (!onMoveTop && !onMoveBottom) return null;

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="p-1 rounded hover:bg-[#EDEDED] transition-colors"
        title="More actions"
        aria-label="More actions"
      >
        <DotsIcon />
      </button>
      {open &&
        createPortal(
          <div
            ref={menuRef}
            className="fixed z-[9999] w-[150px] bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[#F2F2F2]"
            style={{
              top: pos.top !== "auto" ? `${pos.top}px` : "auto",
              bottom: pos.bottom !== "auto" ? `${pos.bottom}px` : "auto",
              right: `${pos.right}px`,
            }}
          >
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                onMoveTop?.();
              }}
              className="w-full text-left px-3 py-2 text-[15px] font-outfit text-[#3F3F46] hover:bg-[#F5F5F5] transition-colors"
            >
              Move to Top
            </button>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                onMoveBottom?.();
              }}
              className="w-full text-left px-3 py-2 text-[15px] font-outfit text-[#3F3F46] hover:bg-[#F5F5F5] transition-colors"
            >
              Move to Bottom
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

const NodeHeader = ({
  node,
  isSub,
  onEdit,
  onHandleMouseDown,
  reorderable = true,
  collapsible = false,
  collapsed = false,
  onToggleCollapse,
  onMoveTop,
  onMoveBottom,
}) => {
  const num = formatNumber(node.number);
  const title = isSub
    ? `${num} ${node.title || ""}`.trim()
    : num
    ? `${num}. ${node.title || ""}`.trim()
    : node.title || "Untitled";

  return (
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        {/* Drag handle sits before the title. Pressing it "arms" the row so it
            becomes draggable. Hidden for non-reorderable nodes (e.g. the
            unnumbered Cover Letter). */}
        {reorderable && (
          <span
            className={`p-1 -ml-1 rounded cursor-grab active:cursor-grabbing hover:bg-[#EDEDED] flex-shrink-0 ${
              isSub ? "opacity-50" : ""
            }`}
            title="Drag to reorder"
            onMouseDown={onHandleMouseDown}
          >
            <DragHandle />
          </span>
        )}
        <h3
          className={`font-outfit font-semibold truncate ${
            isSub ? "text-[15px] text-[#18101C]" : "text-[17px] text-[#A04A97]"
          }`}
        >
          {title}
        </h3>
        <StatusBadge done={!!node.markAsDone} />
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        <Tooltip content={EDIT_TOOLTIP} placement="left">
          <button
            type="button"
            onClick={() => onEdit?.(node)}
            className="flex items-center gap-1.5 px-1.5 py-1 rounded-md  text-[#52525B] font-outfit text-[13px] font-medium hover:bg-[#EDEDED] transition-colors"
          >
            <EditIcon />
          </button>
        </Tooltip>
        {collapsible && (
          <button
            type="button"
            onClick={onToggleCollapse}
            className="p-1 rounded hover:bg-[#EDEDED] transition-colors"
            title={collapsed ? "Expand section" : "Collapse section"}
            aria-label={collapsed ? "Expand section" : "Collapse section"}
          >
            <ChevronIcon collapsed={collapsed} />
          </button>
        )}
        <ActionMenu onMoveTop={onMoveTop} onMoveBottom={onMoveBottom} />
      </div>
    </div>
  );
};

// Renumber nodes optimistically after a reorder, mirroring the backend's reindex
// (1,2,3… for sections; "{sec}.1"… for subs), before the API responds.
const renumber = (list) =>
  list.map((sec, i) => {
    const n = String(i + 1);
    return {
      ...sec,
      number: n,
      children: (sec.children || []).map((sub, j) => ({
        ...sub,
        number: `${n}.${j + 1}`,
      })),
    };
  });

// Move `draggedId` before/after `targetId` within `list`, returning a new array.
const reorderList = (list, draggedId, targetId, placeAfter) => {
  const dragged = list.find((x) => x.id === draggedId);
  if (!dragged) return null;
  const without = list.filter((x) => x.id !== draggedId);
  const ti = without.findIndex((x) => x.id === targetId);
  if (ti === -1) return null;
  without.splice(placeAfter ? ti + 1 : ti, 0, dragged);
  return without;
};

// Whether the cursor is over the top or bottom half of the hovered element.
const computePos = (e, el) => {
  const rect = el.getBoundingClientRect();
  return e.clientY - rect.top < rect.height / 2 ? "before" : "after";
};

// The browser captures the drag ghost from the full-size card at dragstart —
// before React collapses the list — so without this the picked card would float
// full-size while every other card is collapsed. Build a compact, header-only
// stand-in and hand it to setDragImage so the dragged card looks collapsed too.
const buildDragImage = (node, isSub, width) => {
  const num = formatNumber(node.number);
  const title = isSub
    ? `${num} ${node.title || ""}`.trim()
    : num
    ? `${num}. ${node.title || ""}`.trim()
    : node.title || "Untitled";
  const el = document.createElement("div");
  el.style.cssText = `position:absolute;top:-9999px;left:-9999px;box-sizing:border-box;width:${width}px;background:#fff;border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,0.12);padding:${
    isSub ? "12px 20px" : "16px 24px"
  };font-family:'Outfit',system-ui,sans-serif;`;
  const t = document.createElement("span");
  t.textContent = title;
  t.style.cssText = `font-weight:600;font-size:${
    isSub ? "15px" : "17px"
  };color:${isSub ? "#18101C" : "#A04A97"};`;
  el.appendChild(t);
  return el;
};

// Attach a collapsed drag ghost, then clean it up on the next tick (setDragImage
// only needs it to exist for the current event).
const applyCollapsedDragImage = (e, node, isSub) => {
  try {
    const ghost = buildDragImage(node, isSub, e.currentTarget.offsetWidth);
    document.body.appendChild(ghost);
    e.dataTransfer.setDragImage(ghost, 24, isSub ? 16 : 20);
    setTimeout(() => ghost.remove(), 0);
  } catch (_) {}
};

// Read-only review of the proposal: one card per section with nested subsections.
// Sections reorder among themselves; subsections only within their parent. Each
// move is persisted via the reorder API, which renumbers the whole TOC.
const ProposalReviewStep = ({
  apiSections,
  loading = false,
  onEditNode,
  onReordered,
}) => {
  const { projectId } = useParams();
  const location = useLocation();
  const folderId = location?.state?.folderId || projectId;
  const token = localStorage.getItem("token");

  const normalized = useMemo(
    () =>
      apiSections && apiSections.length ? normalizeSections(apiSections) : [],
    [apiSections]
  );

  // Local working copy for optimistic drag; re-seeded when upstream data changes.
  const [items, setItems] = useState(normalized);
  useEffect(() => setItems(normalized), [normalized]);

  // `drag` = node being dragged; `armedId` = row whose handle is pressed (only it
  // is `draggable`); `dropHint` = insertion bar.
  const [drag, setDrag] = useState(null);
  const [armedId, setArmedId] = useState(null);
  const [dropHint, setDropHint] = useState(null);

  // Collapsed sections show only a 2-line content preview and hide their
  // subsections. Keyed by section id; absent/false ⇒ expanded.
  const [collapsedSections, setCollapsedSections] = useState({});
  const toggleCollapse = (id) =>
    setCollapsedSections((prev) => ({ ...prev, [id]: !prev[id] }));

  // While a drag is in progress, force every card into its collapsed preview so
  // the whole list shrinks and every drop target stays on screen. Native HTML5
  // DnD has no reliable auto-scroll, so with tall cards the lower positions were
  // unreachable — which is why a card could only be dropped *above* itself.
  const isDragging = !!drag;
  const isCollapsed = (id) => isDragging || !!collapsedSections[id];

  // If the handle was pressed but no drag started (plain click), disarm on release.
  useEffect(() => {
    const onUp = () => {
      if (!drag) setArmedId(null);
    };
    window.addEventListener("mouseup", onUp);
    return () => window.removeEventListener("mouseup", onUp);
  }, [drag]);

  const persist = async (targetId, targetIndex, prevItems) => {
    if (!folderId) return;
    try {
      await api.post(
        `api/v1/rfp/folders/${folderId}/analysis/reorder/`,
        { target_id: targetId, target_index: targetIndex },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Refresh parent data to reconcile our optimistic renumber with the
      // server-authoritative reindex.
      onReordered?.();
    } catch (error) {
      console.error("Error reordering section:", error);
      setItems(prevItems); // revert the optimistic move
    }
  };

  const resetDrag = () => {
    setDrag(null);
    setArmedId(null);
    setDropHint(null);
  };

  const handleSectionDrop = (targetSection, placeAfter) => {
    if (!drag || drag.kind !== "section" || drag.id === targetSection.id) return;
    const prev = items;
    const reordered = reorderList(items, drag.id, targetSection.id, placeAfter);
    if (!reordered) return;
    const next = renumber(reordered);
    setItems(next);
    const moved = prev.find((x) => x.id === drag.id);
    const targetIndex = next.findIndex((x) => x.id === drag.id) + 1; // 1-based
    persist(moved.targetId || moved.id, targetIndex, prev);
  };

  const handleSubDrop = (parentSection, targetSub, placeAfter) => {
    if (
      !drag ||
      drag.kind !== "sub" ||
      drag.parentId !== parentSection.id ||
      drag.id === targetSub.id
    )
      return;
    const prev = items;
    const reordered = reorderList(
      parentSection.children,
      drag.id,
      targetSub.id,
      placeAfter
    );
    if (!reordered) return;
    const next = renumber(
      items.map((sec) =>
        sec.id === parentSection.id ? { ...sec, children: reordered } : sec
      )
    );
    setItems(next);
    const parentAfter = next.find((s) => s.id === parentSection.id);
    const moved = parentSection.children.find((x) => x.id === drag.id);
    const targetIndex =
      parentAfter.children.findIndex((x) => x.id === drag.id) + 1; // 1-based
    persist(moved.targetId || moved.id, targetIndex, prev);
  };

  // Menu actions: jump a section to the top/bottom of the whole list.
  const moveSectionToEdge = (section, edge) => {
    const others = items.filter((x) => x.id !== section.id);
    if (others.length === items.length) return; // not found
    const prev = items;
    const reordered = edge === "top" ? [section, ...others] : [...others, section];
    const next = renumber(reordered);
    setItems(next);
    const targetIndex = edge === "top" ? 1 : next.length; // 1-based
    persist(section.targetId || section.id, targetIndex, prev);
  };

  // Menu actions: jump a subsection to the top/bottom within its parent section.
  const moveSubToEdge = (parentSection, sub, edge) => {
    const siblings = parentSection.children || [];
    const others = siblings.filter((x) => x.id !== sub.id);
    if (others.length === siblings.length) return; // not found
    const prev = items;
    const reordered = edge === "top" ? [sub, ...others] : [...others, sub];
    const next = renumber(
      items.map((sec) =>
        sec.id === parentSection.id ? { ...sec, children: reordered } : sec
      )
    );
    setItems(next);
    const parentAfter = next.find((s) => s.id === parentSection.id);
    const targetIndex = edge === "top" ? 1 : parentAfter.children.length; // 1-based
    persist(sub.targetId || sub.id, targetIndex, prev);
  };

  if (loading) {
    return (
      <div className="h-full overflow-hidden pr-1 space-y-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="border border-gray-200 rounded-lg p-4 space-y-3"
          >
            <div className="flex items-center justify-between">
              <div className="h-5 w-1/3 rounded bg-gray-200 animate-pulse" />
              <div className="h-4 w-16 rounded bg-gray-200 animate-pulse" />
            </div>
            <div className="space-y-2">
              {[95, 88, 70].map((w, j) => (
                <div
                  key={j}
                  className="h-3 rounded bg-gray-200 animate-pulse"
                  style={{ width: `${w}%` }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="h-full flex items-center justify-center text-center px-6">
        <div>
          <p className="text-[#18101C] font-outfit text-lg font-semibold">
            Nothing to review yet
          </p>
          <p className="text-[#6B7280] font-outfit text-sm mt-1 max-w-[360px]">
            Generate your proposal sections in the Draft step, then come back to
            review them here.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto custom-scrollbar pr-1">
      <style>{`
        .proposal-review-content h1,.proposal-review-content h2,.proposal-review-content h3,.proposal-review-content h4,.proposal-review-content h5,.proposal-review-content h6{font-weight:600;color:#18101C;margin:0.75rem 0 0.4rem;line-height:1.3;}
        .proposal-review-content h4{font-size:15px;}
        .proposal-review-content p{margin:0.4rem 0;}
        .proposal-review-content ul,.proposal-review-content ol{margin:0.4rem 0;padding-left:1.4rem;}
        .proposal-review-content ul{list-style:disc;}
        .proposal-review-content ol{list-style:decimal;}
        .proposal-review-content li{margin:0.15rem 0;}
        .proposal-review-content strong{font-weight:600;color:#18101C;}
        .proposal-review-content a{color:#A04A97;text-decoration:underline;}
        .proposal-review-content table{border-collapse:collapse;width:100%;margin:0.75rem 0;font-size:14px;}
        .proposal-review-content th,.proposal-review-content td{border:1px solid #E5E7EB;padding:0.55rem 0.8rem;text-align:left;vertical-align:top;}
        .proposal-review-content th{background:#FAFAFA;font-weight:600;color:#18101C;}
      `}</style>

      {items.map((section) => {
        // Unnumbered nodes (e.g. Cover Letter) can't be index-reordered, so they're
        // neither draggable nor a drop target — they stay pinned in place.
        const reorderable = !!formatNumber(section.number);
        return (
        <div
          key={section.id}
          draggable={reorderable && armedId === section.id}
          onDragStart={(e) => {
            setDrag({ kind: "section", id: section.id });
            e.dataTransfer.effectAllowed = "move";
            try {
              e.dataTransfer.setData("text/plain", section.id);
            } catch (_) {}
            applyCollapsedDragImage(e, section, false);
          }}
          onDragEnd={resetDrag}
          onDragOver={(e) => {
            if (drag?.kind !== "section" || !reorderable) return;
            e.preventDefault();
            setDropHint({ id: section.id, pos: computePos(e, e.currentTarget) });
          }}
          onDrop={(e) => {
            if (drag?.kind !== "section" || !reorderable) return;
            e.preventDefault();
            const pos =
              dropHint?.id === section.id
                ? dropHint.pos
                : computePos(e, e.currentTarget);
            handleSectionDrop(section, pos === "after");
            resetDrag();
          }}
          className={`relative bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-5 transition-opacity ${
            drag?.id === section.id ? "opacity-50" : ""
          }`}
        >
          {dropHint?.id === section.id && (
            <div
              className={`absolute left-0 right-0 h-[3px] bg-[#A04A97] rounded ${
                dropHint.pos === "before" ? "-top-[3px]" : "-bottom-[3px]"
              }`}
            />
          )}
          <NodeHeader
            node={section}
            isSub={false}
            onEdit={onEditNode}
            onHandleMouseDown={() => setArmedId(section.id)}
            reorderable={reorderable}
            collapsible
            collapsed={!!collapsedSections[section.id]}
            onToggleCollapse={() => toggleCollapse(section.id)}
            onMoveTop={reorderable ? () => moveSectionToEdge(section, "top") : undefined}
            onMoveBottom={reorderable ? () => moveSectionToEdge(section, "bottom") : undefined}
          />
          <NodeContent
            html={section.content}
            clamp={isCollapsed(section.id)}
          />

          {/* Subsections stay mounted and collapse via a grid 0fr↔1fr transition
              so the fold animates smoothly (on manual collapse and during drag). */}
          <div
            className="grid transition-[grid-template-rows] duration-300 ease-in-out"
            style={{ gridTemplateRows: isCollapsed(section.id) ? "0fr" : "1fr" }}
          >
            <div className="overflow-hidden min-h-0">
          {(section.children || []).map((sub) => (
            <div
              key={sub.id}
              draggable={armedId === sub.id}
              onDragStart={(e) => {
                e.stopPropagation();
                setDrag({ kind: "sub", id: sub.id, parentId: section.id });
                e.dataTransfer.effectAllowed = "move";
                try {
                  e.dataTransfer.setData("text/plain", sub.id);
                } catch (_) {}
                applyCollapsedDragImage(e, sub, true);
              }}
              onDragEnd={(e) => {
                e.stopPropagation();
                resetDrag();
              }}
              onDragOver={(e) => {
                if (drag?.kind !== "sub" || drag.parentId !== section.id) return;
                e.preventDefault();
                e.stopPropagation();
                setDropHint({ id: sub.id, pos: computePos(e, e.currentTarget) });
              }}
              onDrop={(e) => {
                if (drag?.kind !== "sub" || drag.parentId !== section.id) return;
                e.preventDefault();
                e.stopPropagation();
                const pos =
                  dropHint?.id === sub.id
                    ? dropHint.pos
                    : computePos(e, e.currentTarget);
                handleSubDrop(section, sub, pos === "after");
                resetDrag();
              }}
              className={`relative mt-5 pt-5 border-t border-gray-100 transition-opacity ${
                drag?.id === sub.id ? "opacity-50" : ""
              }`}
            >
              {dropHint?.id === sub.id && (
                <div
                  className={`absolute left-0 right-0 h-[3px] bg-[#A04A97] rounded ${
                    dropHint.pos === "before" ? "top-0" : "-bottom-[2px]"
                  }`}
                />
              )}
              <NodeHeader
                node={sub}
                isSub
                onEdit={onEditNode}
                onHandleMouseDown={() => setArmedId(sub.id)}
                onMoveTop={() => moveSubToEdge(section, sub, "top")}
                onMoveBottom={() => moveSubToEdge(section, sub, "bottom")}
              />
              <NodeContent html={sub.content} />
            </div>
          ))}
            </div>
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default ProposalReviewStep;
